export const DASHBOARD_PAGE = '/dashboard';
export const LOGIN_PAGE = '/auth/login';

export const GO_TO_DISC_TEST_PAGE = '/test/disc';
export const GO_TO_PROFILE_PAGE = '/settings';
export const GO_TO_MOCK_TEST_PAGE = '/mock/plans';